import React, { useEffect, useRef, useState } from 'react';
import PlaceholderSpinner from 'components/kea/placeholders/PlaceholderSpinner';

export default function WizardVideoDemo({ src, title = 'Demo video', height = '70vh', autoPlay = true }) {
  const [loaded, setLoaded] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    setLoaded(false);
  }, [src]);

  const handleCanPlay = () => setLoaded(true);
  const handleLoadedData = () => setLoaded(true);

  return (
    <div style={{
      position: 'relative',
      width: '100%',
      height,
      borderRadius: 12,
      overflow: 'hidden',
    }}
    >
      {!loaded && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.02)',
            zIndex: 1,
          }}
        >
          <div style={{
            width: '100%',
            maxWidth: 420,
          }}
          >
            <PlaceholderSpinner height={129} />
          </div>
        </div>
      )}

      <video
        ref={videoRef}
        src={src}
        title={title}
        controls
        playsInline
        muted
        loop
        autoPlay={autoPlay}
        onCanPlay={handleCanPlay}
        onLoadedData={handleLoadedData}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
          border: 0,
        }}
      />
    </div>
  );
}
